export default __webpack_public_path__ + "static/media/IMAGE_13.b9902d6f.png";